import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EapStudyTeamTeamViewModalComponent } from './eap-study-team-team-view-modal/eap-study-team-team-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EapStudyTeamOrganizationViewModalComponent } from '../eap-study-team-organization/eap-study-team-organization-view-modal/eap-study-team-organization-view-modal.component';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';

@Component({
  selector: 'app-eap-study-team-team',
  templateUrl: './eap-study-team-team.component.html',
  styleUrls: ['./eap-study-team-team.component.scss']
})
export class EapStudyTeamTeamComponent implements OnInit {

  columnDefs;
  tempoperations;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  staticformFields: any;
  UserRoleList: any[];
  ApplicationID: string;
  studyTeamAdaceSearch: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  Application_Type_ID: string = "";
  ModelData: any = null;
  SCREEN_MODEL: any = null;
  collapesedOrNot: boolean = false;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: EapSummaryService,
    private datashareService: EAPDatashareService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  /**
   * ngOnInit(): Called when component is initialized. Fetches the page permission for "EAP02" screen,
   * subscribes to the ApplicationID observable, fetches the static fields data and screen configuration controls
   * for the screen, sets the user type, creates the advanced search form group, calls the setMasterData() and setSummary() methods.
   */
  ngOnInit() {
    this.studyTeamAdaceSearch = new UntypedFormGroup({
      FirstNAME: new UntypedFormControl(null),
      OrganizationName: new UntypedFormControl(null),
      UserRole: new UntypedFormControl(null),
      Occupation: new UntypedFormControl(null),
      EmailID: new UntypedFormControl(null, [Validators.email]),
      PhoneNumber: new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"), Validators.maxLength(20)])
    });
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = this.commonService.getPagePermission("EAP02").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("EAP02").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.setSummary();
            this.setMasterData();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else{
        this.setSummary();
        this.setMasterData();
    }

    this.getStaticFiledsData('SCR-015'); // Fetch static fields data for the screen
    this.GetScreenConfigControls('SCR-015'); // Fetch screen configuration controls
    this.userType = this.userService.getUserType();
  }

  /**
   * getStaticFiledsData(): Fetches the static fields data for the screen with the given screen code.
   * It then creates the column definitions for the grid by mapping the static field names to the
   * grid column headers.
   * @param screenCode The screen code for which the static fields need to be fetched.
   */
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.columnDefs = [
          {
            "headerName": "Full Name",
            "field": "FirstNAME"
          },
          {
            "headerName": this.staticformFields?.StudyTeam_Org.LABEL_NAME,
            "field": "OrganizationName"
          },
          {
            "headerName": this.staticformFields?.OCCUPATION.LABEL_NAME,
            "field": "Occupation"
          },
          {
            "headerName": this.staticformFields?.EMAIL.LABEL_NAME,
            "field": "EmailID"
          },
          {
            "headerName": this.staticformFields?.PHONE.LABEL_NAME,
            "field": "PhoneNumber"
          }
        ];
      });
  }

  /**
   * GetScreenConfigControls(): Fetches the screen configuration controls for the given screen code and
   * stores it in the SCREEN_MODEL property.
   * @param screenCode The screen code for which the configuration controls need to be fetched.
   */
  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
    });
  }

  /**
   * Sets the grid API instance for the component.
   * This method is used to assign the provided grid API to the component's gridApi property,
   * enabling interaction with the grid such as accessing its data and controlling its behavior.
   *
   * @param gridApi - The grid API instance to be set for the component.
   */
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  /**
   * Executes the callback function provided in the operation object.
   * This method is triggered when a callback operation is emitted from the grid,
   * and it invokes the callback method attached to the operation.
   *
   * @param opr - The operation object containing the callback function to be executed.
   */
  onCallbackOperation(opr) {
    opr.callback();
  }

  /**
   * Sets the selected row in the component when a selection change event is fired by the grid.
   * The selected row is stored in the selectedRow property and can be used to perform operations
   * such as editing or deleting a row.
   *
   * @param event - The selection changed event emitted by the grid.
   */
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  /**
   * Handles the double click event on a grid row. Opens a modal to view the clicked study team team member.
   * @param event The double click event emitted by the grid.
   */
  onRowDoubleClicked(event) {
    const ModelRef = this.modalService.open(EapStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg modal-full-height modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content = {
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  /**
   * Navigates to the study team team request form for the EAP application.
   * This method uses the Angular router to change the route to the specified path
   * without updating the browser's location (URL).
   */
  add_open_form() {
    (this['self'] as EapStudyTeamTeamComponent).router
      .navigate(['/home/eap/applications/application-ext/:1/study_team_team_request/study_team_team_request/:1'], { skipLocationChange: true })
  }

  /**
   * Opens a modal to add a new study team team member.
   * This method opens a modal with the study team team member form pre-populated with the current EAP application ID.
   * The modal is configured to be a large (lg) modal with a right (modal-right) class.
   * If the modal is closed, the component will call the setSummary() method.
   */
  add() {
    var emptyList = [];
    this.datashareService.setEapMemberOrgList(emptyList);
    let modalRef = this.modalService.open(EapStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }

    modalRef.result.then(result => {
      this.setSummary();
    })
  }

  /**
   * Opens a modal to edit a study team team member.
   * This method opens a modal with the study team team member form pre-populated with the current EAP application ID.
   * The modal is configured to be a large (lg) modal with a right (modal-right) class.
   * If the modal is closed, the component will call the setSummary() method.
   * @param RecordData The data of the record to be edited, including its ID.
   */
  edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(EapStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'], ApplicationID: this.ApplicationID }
    }

    modalRef.result.then(result => {
      (this['self'] as EapStudyTeamTeamComponent).setSummary();
    })
  }

  /**
   * Opens a modal to view the details of a study team team member.
   * The modal is configured with the current EAP application ID and the record ID of the team member.
   * It is displayed as a large modal positioned on the right side.
   * Upon closing the modal, the component will update the summary data.
   * @param RecordData The data of the record to be viewed, containing its ID.
   */
  view(RecordData: any) {
    let modalRef = this["self"].modalService.open(EapStudyTeamTeamViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: RecordData['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      (this['self'] as EapStudyTeamTeamComponent).setSummary();
    })
  }

  /**
   * Opens a modal to delete a study team team member.
   * The modal is configured with the name of the team member and a custom message to confirm the deletion.
   * It is displayed as a small modal positioned on the center of the window.
   * Upon closing the modal, the component will delete the record and update the summary data if the deletion is successful.
   * If the record is created by Admin, the component will show a validation banner instead of deleting the record.
   * @param RecordData The data of the record to be deleted, containing its ID.
   */
  delete(RecordData: any) {
    let id = RecordData['ID'];
    let Name = RecordData['FirstNAME'];

    if (RecordData["CREATED_BY"] != "Admin") {

      const modalRef = (this['self'] as EapStudyTeamTeamComponent).modalService.open(DeleteBoxComponent, {
        backdrop: false
      })
      modalRef.componentInstance.Content = {
        heading: 'Delete',
        custommessage: 'The Team member ' + "'" + Name + "'" + ' will be deleted. Do you want to proceed?',
        ProceedButtonName: "Yes",
        TerminateButtonName: "No"
      }
      modalRef.result.then(result => {
        if (result == "okclick") {
          (this['self'] as EapStudyTeamTeamComponent).summaryService.DeleteRecord('api/EAPStudyTeam/Delete?RecordID=' + id).subscribe(summary => {

            if (summary["Status"] == 0) {
              (this['self'] as EapStudyTeamTeamComponent).commonService.SuccessBanner(summary["Message"]);
              (this['self'] as EapStudyTeamTeamComponent).setSummary();
            }
            else {
              (this['self'] as EapStudyTeamTeamComponent).commonService.ValidationBanner(summary["Message"]);
            }
          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Default Record can't be Deleted");
    }
  }

  /**
   * Opens a modal to add a new study team team member's organization.
   * The modal is configured with an empty organization object and the current EAP application ID.
   * It is displayed as a large modal positioned on the right side.
   * The modal is configured to be a large (lg) modal with a right (modal-right) class.
   * The modal is also configured to be closed by pressing the escape key or by clicking outside of the modal.
   * The modal is also configured to have animation.
   */
  add_org() {
    let modalRef = (this['self'] as EapStudyTeamTeamComponent).modalService.open(EapStudyTeamOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: '', ApplicationID: this.ApplicationID }
    }
  }

  /**
   * This method takes an array of operations and returns an array of objects.
   * The objects contain the name of the operation, a callback function and a self reference.
   * If the operation id is 'add' or 'view_modal', the object will have an additional property 'disabled' set to false.
   * This method is used to set the operations for the grid.
   * @param parmoperations An array of objects containing the name and id of the operations.
   * @returns An array of objects containing the name, callback, self and disabled (if applicable) properties.
   */
  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? {
        name: operation.name,
        callback: this[operation.id],
        self: this,
        disabled: 'false'
      } : {
        name: operation.name,
        callback: this[operation.id],
        self: this
      }
    });
    return this.operations;
  }

  /**
   * Configures and assigns a set of operations to each element in the provided RawData array.
   * The operations are determined by the user's permission level and the creator of each element.
   *
   * If the permission is "new", an "Add" operation is included in the operations list. For elements
   * created by "Admin" or with a permission level of "view", a simplified set of operations is assigned.
   *
   * The function modifies each element in RawData by adding an "Operations" property, which contains
   * an array of operation objects. Each operation object includes a name, a callback function,
   * and a reference to the component instance.
   *
   * After assigning operations, the grid columns are resized to fit the new content.
   *
   * @param RawData - An array of data elements to which operations will be assigned.
   * @returns The modified RawData array with assigned operations for each element.
   */
  setOperations(RawData: any): any {
    let tempoperations = [
      {
        "name": "View",
        "id": "view"
      },
      {
        "name": "Edit",
        "id": "edit"
      },
      {
        "name": "Delete",
        "id": "delete"
      }
    ];

    if (this.permission == "new") {
      tempoperations.push({
        "name": "Add",
        "id": "add"
      });
    }

    let tempoperations2 = [
      {
        "name": "View",
        "id": "view"
      }
    ];

    if (this.permission == "new") {
      tempoperations2.push({
        "name": "Add Member",
        "id": "add"
      });
    }

    if (this.permission == "edit") { }

    RawData.forEach(element => {
      if (element.CREATED_BY == "Admin" || this.permission == "view") {
        element["Operations"] = this.setDef(tempoperations2);
      }
      else {
        element["Operations"] = this.setDef(tempoperations);
      }
    });

    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    }, 500);

    return RawData;
  }

  /**
   * Fetches search data using the provided form data and updates the rowData.
   * Uses the summaryService to call the API endpoint for fetching summary search data,
   * and processes the received summary data by applying setOperations.
   * @param formData The form data used for the search query.
   */
  getSearchData(formData) {
    this.summaryService.fetchSearchData("api/EAPStudyTeam/GetSummarySearchData", formData)
      .subscribe({
        next: summary => {
          this.rowData = this.setOperations(summary);
        }
      });
  }

  /**
   * Clears the advanced search form and fetches the summary data for the grid based on the ApplicationID.
   * If the ApplicationID is not provided, the rowData is set to an empty array.
   */
  setSummary() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData("api/EAPStudyTeam/GetSummaryData?ApplicationID=" + this.ApplicationID)
        .subscribe({
          next: summary => {
            this.rowData = this.setOperations(summary);
          }
        });
    }
    else {
      this.rowData = [];
    }
  }

  /**
   * Fetches master data using the provided ApplicationID and updates the UserRoleList.
   * Uses the summaryService to call the API endpoint for fetching master data,
   * and processes the received summary data by extracting the UserRoleList and adding a default 'Select' option.
   */
  setMasterData() {
    this.summaryService.masterData("api/EAPStudyTeam/GetMasterDataSearch?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.UserRoleList = summary["MasterData2"];
      this.UserRoleList = [{ label: "Select", value: "", checked: true }].concat(this.UserRoleList);
    });
  }

  /**
   * Resets the advanced search form by calling the reset() method on the form group.
   * This clears the values of all the form controls and sets the form back to its pristine state.
   */
  SearchClear() {
    this.studyTeamAdaceSearch.reset();
  }

  /**
   * Validates the input character on key press for the phone number field.
   * Prevents the user from entering any characters other than digits, +, -, and space.
   * @param event The key press event.
   */
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      event.value = '';
    }
  }

  /**
   * Validates the input email address on change.
   * If the email address is invalid, adds the ng-touched, ng-invalid, and validate-error classes to the input element
   * and removes the ng-untouched and ng-valid classes. Displays a validation banner with the error message.
   * If the email address is valid, removes the ng-touched, ng-invalid, and validate-error classes from the input element
   * and adds the ng-untouched and ng-valid classes.
   * @param event The change event emitted by the input element.
   */
  validEmail(event: any) {
    if (this.commonService.validateEmail(event.value)) {
      document.getElementById("EMAIL").classList.remove(...["ng-touched", "ng-invalid", "validate-error"]);
      document.getElementById("EMAIL").classList.add(...["ng-untouched", "ng-valid"]);
    }
    else {
      document.getElementById("EMAIL").classList.add(...["ng-touched", "ng-invalid", "validate-error"]);
      document.getElementById("EMAIL").classList.remove(...["ng-untouched", "ng-valid"]);

      this.commonService.ValidationBanner("please enter valid Email ID<br/>");
    }
  }

  /**
   * Validates the search form.
   * If the form is valid and none of the fields have a value, adds the error message "Please enter at least one criteria to perform search"
   * to the error array and displays a validation banner with the error message. Returns false.
   * If the form is invalid or any of the fields have a value, returns true.
   */
  ValidateForm() {
    let err: string[] = [];
    if (this.studyTeamAdaceSearch.valid) {
      if (
        !this.studyTeamAdaceSearch.controls["FirstNAME"].value &&
        !this.studyTeamAdaceSearch.controls["OrganizationName"].value &&
        !this.studyTeamAdaceSearch.controls["UserRole"].value &&
        !this.studyTeamAdaceSearch.controls["Occupation"].value &&
        !this.studyTeamAdaceSearch.controls["EmailID"].value &&
        !this.studyTeamAdaceSearch.controls["PhoneNumber"].value
      ) {
        err.push("Please enter at least one criteria to perform search");
        this.commonService.ValidationBanner(err)
        return false;
      }
    }
    return true;
  }

  /**
   * Advances the search by populating the grid with the results of the search query.
   * If the form is valid and none of the fields have a value, displays a validation banner with the error message
   * "Please enter at least one criteria to perform search". Otherwise, calls the getSearchData method with the
   * form values and the Application ID.
   */
  AdvanceSearch() {
    if (this.ValidateForm()) {
      var formData = this.studyTeamAdaceSearch.value;
      formData["ApplicationID"] = this.ApplicationID;
      this.getSearchData(formData);
    }
  }
}
